import { render, staticRenderFns } from "./DatosPersonales.vue?vue&type=template&id=047ab14b&scoped=true"
import script from "./DatosPersonales.vue?vue&type=script&lang=js"
export * from "./DatosPersonales.vue?vue&type=script&lang=js"
import style0 from "./DatosPersonales.vue?vue&type=style&index=0&id=047ab14b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047ab14b",
  null
  
)

export default component.exports